import { renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _ctx.autoTeleport || _ctx.fallback,
    disabled: !_ctx.autoTeleport && !_ctx.fallback
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, ["to", "disabled"]))
}